import { MENUS } from "../config/menus";

export const getNavStyle = (
  selectedMenu: string | undefined,
  selectedMenuId: string | undefined,
  menuItem: string,
  id?: string
) => {
  let style = "";

  switch (menuItem) {
    default:
      style = menuItem === selectedMenu ? "menu-nav-on" : "menu-nav-off";
  }

  return style;
};

export const getMenuStyle = (
  selectedMenu: string | undefined,
  selectedMenuId: string | undefined,
  menuItem: string,
  id?: string
) => {
  let style = "";

  switch (menuItem) {
    default:
      style = menuItem === selectedMenu ? "menu-text-on" : "menu-text";
  }

  return style;
};
